export default "__VITE_ASSET__CB4qgE5D__"